import { GET_CONTRACT_TYPES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_CONTRACT_TYPES] (state, contractTypes) {
    state.all = contractTypes
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/contractTypes.js